import React, { useState, useRef } from 'react';
import {
    FilterBarContainer,
    FilterBarLeftContent,
    FilterBarRightContent,
} from "./Filters.styled";
import { Button, Autocomplete, SwitchMode, SortMenu } from "@ann/web-components";
import { useDrivesStores } from '../../../../hook/use-drives.hook';

const Filters = ({ 
    mode, 
    setMode, 
    onFilterChange, 
    onSortChange, 
    sortBy, 
    sortDirection,
    filterText = ""
}) => {
    const { myWorkspacesStore } = useDrivesStores();
    const [autocompleteValue, setAutocompleteValue] = useState(filterText);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const autocompleteRef = useRef(null);

    const handleAutocompleteChange = (value) => {
        setAutocompleteValue(value);
        if (onFilterChange) {
            onFilterChange(value);
        }
    };

    const handleAutocompleteClear = () => {
        setAutocompleteValue("");
        setAutocompleteKey(prev => prev + 1);
        if (onFilterChange) {
            onFilterChange("");
        }
    };

    const handleClearAllFilters = () => {
        setAutocompleteValue("");
        setAutocompleteKey(prev => prev + 1);
        if (onFilterChange) {
            onFilterChange("");
        }
    };

    const hasActiveFilters = autocompleteValue.trim() !== "";

    return (
        <FilterBarContainer>
            <FilterBarLeftContent>
                <Autocomplete
                    style={{ fontSize: "5px" }}
                    key={autocompleteKey}
                    ref={autocompleteRef}
                    value={autocompleteValue}
                    onChange={handleAutocompleteChange}
                    onSearch={() => { }}
                    onSuggestionSelect={() => { }}
                    onClear={handleAutocompleteClear}
                    placeholder="Search"
                    suggestions={[]}
                />

                {hasActiveFilters && (
                    <Button
                        icon=""
                        iconLeft=""
                        iconRight=""
                        label="Clear Filters"
                        size="medium"
                        type="secondary"
                        onClick={handleClearAllFilters}
                    />
                )}
            </FilterBarLeftContent>

            <SortMenu
                minWidth="200px"
                onChange={(id) => {
                    if (onSortChange) {
                        onSortChange(id);
                    }
                }}
                onOrderChange={() => {
                    if (onSortChange) {
                        onSortChange(sortBy);
                    }
                }}
                options={[
                    {
                        icon: 'clock',
                        id: 'lastUpdated',
                        label: 'Most Recent'
                    },
                    {
                        icon: 'sortByAlpha',
                        id: 'name',
                        label: 'Name (A-Z)'
                    }
                ]}
                order={sortDirection}
                selected={sortBy}
                size="medium"
                title="SORT BY"
                width="200px"
            />

            <FilterBarRightContent>
              
            </FilterBarRightContent>
        </FilterBarContainer>
    );
};

export default Filters;
